module.exports = __webpack_public_path__ + "static/media/img_10.7bd99c83.png";